import { useTranslation } from 'react-i18next';
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Button,
  HStack,
  Stack,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faClock } from '@fortawesome/pro-regular-svg-icons';
import ActionMenu, { EditMenuItem } from 'components/ActionMenu';
import ModalWrapper from 'components/ModalWrapper';
import MembersButton from 'components/MembersButton';
import FieldTable from './FieldTable';
import InboxStepForm from './InboxStepForm';
import StepReminderForm from './StepReminderForm';

const InboxStepListItem = ({
  workflow,
  onSubmit,
  onFieldChangeStep,
  onUpdateWorkflow,
  isOpen
}) => {
  const { t } = useTranslation();
  const {
    isOpen: showUpdateStepModal,
    onOpen: openUpdateStepModal,
    onClose: closeUpdateStepModal
  } = useDisclosure();

  const {
    isOpen: showSetReminderModal,
    onOpen: openSetReminderModal,
    onClose: closeSetReminderModal
  } = useDisclosure();

  const handleOnSubmit = async values => {
    await onSubmit(values);
    closeUpdateStepModal();
  };

  return (
    <AccordionItem borderWidth={0} borderBottom="none" borderTopWidth="1px">
      <HStack spacing={4} py={4}>
        <Text variant="light">
          <FontAwesomeIcon icon={faLock} />
        </Text>
        <AccordionButton
          px={0}
          _hover={{
            bg: null
          }}
        >
          <HStack spacing={4} width="full">
            <Badge>{t('common.inbox')}</Badge>
          </HStack>
          <AccordionIcon ml={2} />
        </AccordionButton>
        <ActionMenu>
          <EditMenuItem onClick={openUpdateStepModal} />
        </ActionMenu>
      </HStack>
      <AccordionPanel pb={8}>
        <Stack spacing={4}>
          <HStack
            spacing={4}
            width="full"
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <Stack spacing={2}>
              <Text variant="muted">{t('common.reminder')}</Text>
              <Button
                width="full"
                variant="outline"
                size="sm"
                onClick={openSetReminderModal}
                leftIcon={<FontAwesomeIcon icon={faClock} />}
              >
                <Text color={workflow.inbox_reminder_days ? null : 'gray'}>
                  {workflow.inbox_reminder_days
                    ? workflow.inbox_reminder_days
                    : '-'}
                </Text>
              </Button>
            </Stack>
            <Stack spacing={2}>
              <Text textAlign="center" variant="muted">
                {t('common.panel')}
              </Text>
              <MembersButton
                size="sm"
                max={3}
                members={workflow.inbox_panel}
                onSubmit={async ({ members }) => {
                  let panel = members.map(member => member.id);
                  await onUpdateWorkflow({ inbox_panel: panel });
                }}
                canEdit
              />
            </Stack>
          </HStack>
          <FieldTable
            step={null}
            workflow={workflow}
            onFieldChangeStep={onFieldChangeStep}
            isOpen={isOpen}
          />
        </Stack>
      </AccordionPanel>
      <ModalWrapper
        size="md"
        title={t('workflow.set_reminder')}
        isOpen={showSetReminderModal}
        onClose={closeSetReminderModal}
        confirmClosure
      >
        <Stack spacing={4}>
          <Text fontSize="sm">{t('workflow.reminder_explainer')}</Text>
          <StepReminderForm
            defaultValues={{
              reminder_days: workflow.inbox_reminder_days
            }}
            isOpen={showSetReminderModal}
            onDelete={async () => {
              await handleOnSubmit({ inbox_reminder_days: null });
              closeSetReminderModal();
            }}
            onSubmit={async ({ reminder_days }) => {
              await handleOnSubmit({ inbox_reminder_days: reminder_days });
              closeSetReminderModal();
            }}
          />
        </Stack>
      </ModalWrapper>
      <ModalWrapper
        title={t('common.step')}
        isOpen={showUpdateStepModal}
        onClose={closeUpdateStepModal}
      >
        <InboxStepForm
          defaultValues={{
            hide_inbox_cards: workflow.hide_inbox_cards,
            inbox_use_reactions: workflow.inbox_use_reactions
          }}
          isOpen={showUpdateStepModal}
          onSubmit={handleOnSubmit}
        />
      </ModalWrapper>
    </AccordionItem>
  );
};

export default InboxStepListItem;
